import { FocusMonitor } from '@angular/cdk/a11y';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, Optional, Self, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgControl, NgForm, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImpressaoService } from 'src/app/services/impressao/impressao.service';
import { AbstractMatFormField } from '../../base/abstract-mat-form-field';

export interface Impressora {
    connectionId: string,
    nomeImpressora: string
}

@Component({
    selector: 'app-impressoras-autocomplete',
    providers: [
        {
          provide: MatFormFieldControl,
          useExisting: ImpressorasAutoCompleteComponent
        }
      ],
    templateUrl: './impressoras-autocomplete.component.html',
    styleUrls: ['./impressoras-autocomplete.component.scss']
})
export class ImpressorasAutoCompleteComponent
    extends AbstractMatFormField<Impressora>
    implements OnInit, OnDestroy {

    @ViewChild(MatSelect, { static: false })
    private input: MatSelect;

    private subscription: Subscription;

    @Input() isRequired: boolean = false;


    impressorasResponse: any[] = [];
    impressorasNomes: any[] = [];
    selected: string = localStorage['printer'];
    private onDestroy = new Subject<void>();

    constructor(
        @Optional() @Self() ngControl: NgControl,
        @Optional() _parentForm: NgForm,
        @Optional() _parentFormGroup: FormGroupDirective,
        _defaultErrorStateMatcher: ErrorStateMatcher,
        _focusMonitor: FocusMonitor,
        _elementRef: ElementRef,
        public snackBar: MatSnackBar,
        private impressaoService: ImpressaoService,
    ) {
        super(
            //"app-impressoras-autocomplete",
            ngControl,
            _parentForm,
            _parentFormGroup,
            _defaultErrorStateMatcher,
            _focusMonitor,
            _elementRef
        );
    }

    public ngOnInit(): void {
        this.listarImpressoras();
        // this.subscription = this.control.valueChanges.subscribe(value => {
        //     super.value = value;
        // });
    }


    public override ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        super.ngOnDestroy();
    }

    public focus(): void {
        this.input.focus();
    }

    public filteredImpressora: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    public impressoraMultiFilter: FormControl = new FormControl();

    listarImpressoras() {
        this.impressaoService.listarImpressoras().subscribe
            (response => {
                this.impressorasResponse = response.filter((x) => x.impressora).sort();
                this.impressorasNomes = this.impressorasResponse.map(i => i.impressora).filter(this.onlyUnique).sort();
                this.filteredImpressora.next(this.impressorasNomes.slice());
                this.impressoraMultiFilter.valueChanges
                    .pipe(takeUntil(this.onDestroy))
                    .subscribe(() => {
                        this.filtroGeral(
                            this.impressorasNomes,
                            this.impressoraMultiFilter,
                            this.filteredImpressora
                        );
                    });
                this.selected = localStorage['printer'];
                if (this.selected) {
                    this.value = {
                        connectionId: this.getConnectionId(this.selected),
                        nomeImpressora: this.selected
                    };
                }
            },
                (err: HttpErrorResponse) => {
                    console.error(err);
                    this.openSnackBar(
                        "Erro ao carregar impressoras, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
                        "OK",
                        10000,
                        "danger-snackbar"
                    );
                }
            );
    }

    private onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    private filtroGeral(filtro: any, multifilter: any, filtered: any) {
        if (!filtro) {
            return;
        }
        let search = multifilter.value;
        if (!search) {
            filtered.next(filtro.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        filtered.next(
            filtro.filter(response => response.toLowerCase().indexOf(search) > -1)
        );
    }

    salvarImpressora() {
        this.onTouched();
        this.value = {
            connectionId: this.getConnectionId(this.selected),
            nomeImpressora: this.selected
        };
        localStorage['printer'] = this.selected;
    }

    getConnectionId(impressora) {
        var response = this.impressorasResponse.filter(res => {
            return res.impressora == impressora
        })[0]?.connectionId;
        return response;
    }

    openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
        this.snackBar.open(message, action, { duration, panelClass });
    }
}
